<template>
  <div class="notifications">
    <h1>Notifikacije</h1>
    <div id="read-all">
      <button class="btn btn-primary" @click="markAllAsRead()" v-if="hasUnread">
        <span>Označi sve kao pročitane</span>
        <spinner :size="20" line-fg-color="#00796b" v-if="isLoading" />
      </button>
    </div>
    <data-table
      @row-click="handleRowClick"
      :columns="tableColumns"
      :tableData="tableData"
      :options="tableOptions"
      :slotNotificationStatus="'is_read'"
      :slotDate="'timestamp'"
    ></data-table>
    <button
      type="button"
      class="btn btn-primary btn-load-more"
      @click="loadMore"
      :disabled="isLoadingMore"
      v-if="showLoadMore"
    >
      Učitaj još
      <spinner
        class="spinner"
        :size="20"
        line-fg-color="#00796b"
        v-if="isLoadingMore"
      />
    </button>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import dataTable from '@/components/community/Table.vue';
import Pagination from '@/components/common/Pagination.vue';

const util = {
  createNotificationBody(el) {
    switch (el.type) {
      case '6':
        return `${el.full_name} je izmenio tiket u zajednici ${el.address} ${
          el.street_number
        }`;
      case '8':
        return el.preview + ' ' + el.address + ' ' + el.street_number;
      case '10':
        return `${el.full_name} je poslao zahtev da se pridruži zajednici ${
          el.address
        } ${el.street_number}`;
      case '2':
        return `${el.full_name} je pokrenuo glasanje u zajednici ${
          el.address
        } ${el.street_number}`;
      case '5':
        return `${el.full_name} je postavio novi tiket u zajednici ${
          el.address
        } ${el.street_number}`;
      case '1':
        return `${el.full_name} je postavio novu objavu u zajednici ${
          el.address
        } ${el.street_number}`;
      case '3':
        return `${el.full_name} je kreirao događaj u zajednici ${el.address} ${
          el.street_number
        }`;
      case '4':
        return `${el.full_name} je komentarisao objavu u zajednici ${
          el.address
        } ${el.street_number}`;
      case '11':
        return `${el.full_name} je obrisao račun u zajednici ${el.address} ${
          el.street_number
        }`;
      case '12':
        return `${el.full_name} je dodao račun u zajednici ${el.address} ${
          el.street_number
        }`;
      case '13':
        return `Imate novi podsetnik u zajednici ${el.address} ${
          el.street_number
        }`;
    }
  }
};

export default {
  name: 'notificationView',
  created() {
    this.fetchNotifications();
    this.refreshInterval = setInterval(() => {
      this.fetchNewNotifications();
    }, 4000);
  },
  data() {
    return {
      currentTableData: [],
      isLoading: false,
      isLoadingMore: false,
      hasUnread: false,
      restructuredData: [],
      showLoadMore: true,
      refreshInterval: null
    };
  },
  computed: {
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  components: {
    dataTable
    // Pagination
  },
  methods: {
    ...mapActions('table', ['initTable']),
    ...mapMutations('table', ['setTableData']),
    ...mapMutations('poll', ['setBasicPollInfo']),
    ...mapActions('poll', ['getPollDetails']),
    ...mapMutations('ticket', ['setBasicInfo']),
    ...mapActions('ticket', ['getTicketDetails']),
    ...mapActions('modal', ['showSuccessModal']),
    fetchNotifications() {
      axios
        .get('notifications/?offset=0&isManager=1')
        .then(({ data }) => {
          if (data) {
            this.restructuredData = data.map(el => {
              return {
                ...el,
                body: util.createNotificationBody(el)
              };
            });
            this.initTable('notificationsTable');
            console.log('notifs', this.restructuredData);
            this.setTableData(this.restructuredData);
            for (let n of this.restructuredData) {
              if (n.is_read === '0') {
                this.currentTableData.push(n.id);
                this.hasUnread = true;
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    fetchNewNotifications() {
      axios
        .get('notifications/?offset=0&isManager=1')
        .then(({ data }) => {
          if (data) {
            const restructuredNewData = data.map(el => {
              return {
                ...el,
                body: util.createNotificationBody(el)
              };
            });
            let newNotifications = [];
            for (let n of restructuredNewData) {
              if (
                n.is_read === '0' &&
                this.currentTableData.indexOf(n.id) == -1
              ) {
                this.currentTableData.push(n.id);
                newNotifications.push(n);
                this.hasUnread = true;
              }
            }
            if (newNotifications.length > 0) {
              this.restructuredData.unshift(...newNotifications);
              this.setTableData(this.restructuredData);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async loadMore() {
      try {
        this.isLoadingMore = true;
        let data = await axios.get(
          `notifications/?offset=${this.restructuredData.length}&isManager=1`
        );
        data = data.data;
        if (data) {
          if (data.length === 0) {
            this.showLoadMore = false;
            return;
          }

          const newData = data.map(el => {
            return {
              ...el,
              body: util.createNotificationBody(el)
            };
          });
          this.restructuredData.push(...newData);
          this.setTableData(this.restructuredData);
          for (let n of this.restructuredData) {
            if (n.is_read === '0') {
              this.currentTableData.push(n.id);
              this.hasUnread = true;
            }
          }
        }
        this.isLoadingMore = false;
      } catch (error) {
        console.log(error);
        this.isLoadingMore = false;
      }
    },
    handleRowClick(e) {
      const activeCommunity = this.$store.getters.getActiveCommunity;
      const activeCommunityId = activeCommunity.community_id;

      const activeCommunityName =
        activeCommunity.address +
        ' ' +
        activeCommunity.street_number +
        ', ' +
        activeCommunity.municipality_name;
      switch (e.row.type) {
        case '10':
          //member
          if (activeCommunityId != e.row.community_id) {
            const newCommunity = this.$store.getters.getCommunitiesImploded.find(
              c => c.id == e.row.community_id
            );
            const name = newCommunity ? newCommunity.name : '';
            this.$store.commit('setActiveCommunity', e.row.community_id);
            this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
          }
          this.$router.push({
            path: `/community/${e.row.community_id}/members`
          });
          break;
        case '2':
          //vote
          if (activeCommunityId != e.row.community_id) {
            const newCommunity = this.$store.getters.getCommunitiesImploded.find(
              c => c.id == e.row.community_id
            );
            const name = newCommunity ? newCommunity.name : '';
            this.$store.commit('setActiveCommunity', e.row.community_id);
            this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
          }
          this.setBasicPollInfo({
            pollId: e.row.post_id
          });
          // this.getPollDetails();
          this.$router.push({
            path: `/poll/${e.row.post_id}`
          });
          break;
        case '5':
        case '6':
          //ticket
          if (activeCommunityId != e.row.community_id) {
            const newCommunity = this.$store.getters.getCommunitiesImploded.find(
              c => c.id == e.row.community_id
            );
            const name = newCommunity ? newCommunity.name : '';
            this.$store.commit('setActiveCommunity', e.row.community_id);
            this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
          }
          this.setBasicInfo({
            ticketId: e.row.ticket_id
          });
          this.getTicketDetails();
          this.$router.push({
            path: `/ticket/${e.row.ticket_id}`
          });
          break;
        case '1':
          //objava
          //TODO
          break;
        case '3':
          //EVENT
          //TODO
          break;
        case '13':
          if (!e.row.reminder_id) {
            return;
          }
          if (e.row.community_id != this.$store.getters.getActiveCommunity.id) {
            this.$store.commit('setActiveCommunity', e.row.community_id);
            const community = this.$store.getters.getCommunities.find(
              c => c.community_id == e.row.community_id
            );
            const name = community.address + ' ' + community.street_number;
            this.$toasted.show(`Izabrana zajednica promenjena na: ${name}`);
          }
          this.$router.push({
            name: 'communityReminderDetails',
            params: {
              id: e.row.community_id,
              reminderId: e.row.reminder_id
            }
          });
          break;
        default:
          console.log(e);
      }
    },
    async markAllAsRead() {
      try {
        this.isLoading = true;
        await axios.get('notifications/read/all');
        this.tableData.forEach(notif => {
          notif.is_read = '1';
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    }
  },
  destroyed() {
    clearInterval(this.refreshInterval);
    if (this.currentTableData.length !== 0) {
      axios
        .post('notifications/read', {
          notification_ids: this.currentTableData
        })
        .then(() => {
          this.$store.commit('resetNotifications');
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="scss">
.btn-load-more {
  display: flex;
  align-items: center;
  .spinner {
    margin-left: 8px;
  }
}
.notifications {
  width: 100%;
  height: 100%;
  padding: 50px 10px 0 10px;

  tr td:nth-child(2) {
    width: 0.5% !important;
  }
}
#read-all {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  span {
    margin-right: 8px;
  }
  button {
    display: flex;
  }
}
</style>
